module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.playing != null) ? _c('div', {
    staticClass: "now-playing",
    style: ({
      backgroundImage: _vm.playing.artwork !== null ? ("url('" + (_vm.secureArtwork(_vm.playing.artwork)) + "')") : ""
    })
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.playing.artwork !== null) ? _c('div', {
    staticClass: "artwork"
  }, [_c('img', {
    attrs: {
      "src": _vm._f("secure")(_vm.playing.artwork),
      "alt": _vm.playing.track
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "track-info"
  }, [_c('h1', {
    staticClass: "artist"
  }, [_vm._v(_vm._s(_vm.playing.artist))]), _vm._v(" "), _c('h2', {
    staticClass: "track"
  }, [_vm._v(_vm._s(_vm.playing.track))]), _vm._v(" "), (_vm.playing.game) ? _c('h3', {
    staticClass: "game"
  }, [_vm._v(_vm._s(_vm.playing.game))]) : _vm._e()]), _vm._v(" "), (_vm.playing.stats && _vm.playing.stats.hasOwnProperty('is_new')) ? _c('div', {
    staticClass: "track-stats",
    class: {
      'no-artwork': !_vm.playing.artwork
    }
  }, [(_vm.playing.stats.is_new === true) ? _c('span', {
    staticClass: "plays tag is-primary is-medium is-new-track"
  }, [_vm._v("New")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "href": ("https://last.fm/music/" + (_vm.playing.artist) + "/_/" + (_vm.playing.track)),
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-lastfm"
  }), _vm._v("Purchase on last.fm")])]), _vm._v(" "), (_vm.playing.stats && _vm.playing.stats.is_new !== true) ? [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "plays"
  }, [_vm._v(_vm._s(_vm.playing.stats.play_count + " play" + (_vm.playing.stats.play_count == 1 ? "" : "s")))]), _vm._v(" "), _c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "last-played"
  }, [_vm._v(_vm._s("Last played: " + _vm.getLastPlayedDate(_vm.playing.stats.last_played)))])] : _vm._e()], 2) : _vm._e()])]) : _c('div', {
    staticClass: "now-playing loading"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93d7511a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/NowPlaying.vue
// module id = 275
// module chunks = 1